//실제 서버 연결 테스트용
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import { initializeSecureSDK } from './utils/secureSDK'
import PortalVue from 'portal-vue'

Vue.config.productionTip = false

// INIHuB SDK 로드 함수
function loadInihubScript() {
  return new Promise((resolve, reject) => {
    if (window.IHUB_C) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `${process.env.VUE_APP_INIHUB_BASE_URL}/client/inihub.js?dt=20250808`;
    script.async = true;
    script.onload = () => {
      console.log('[INIHUB] SDK 스크립트 로드 완료');
      resolve();
    };
    script.onerror = () => reject(new Error('INIHuB 스크립트 로드 실패'));
    document.head.appendChild(script);
  });
}

// INIHuB 초기화
async function initializeInihub() {
  try {
    await loadInihubScript();

    if (typeof window.IHUB_C === 'undefined') {
      throw new Error('IHUB_C가 정의되지 않음');
    }

    await window.IHUB_C.init({
      baseUrl: process.env.VUE_APP_INIHUB_BASE_URL,
      clientId: process.env.VUE_APP_INIHUB_CLIENT_ID,
      appKey: process.env.VUE_APP_INIHUB_APP_KEY
    });

    console.log('[INIHUB] 초기화 완료');
    Vue.prototype.$ihub = window.IHUB_C;
    store.commit('SET_IHUB_READY', true);
  } catch (error) {
    console.error('[INIHUB] 초기화 실패:', error);
    store.commit('SET_IHUB_ERROR', error.message || 'INIHuB 초기화 실패');
  }
}

// INIHuB 초기화 시작
initializeInihub();

function loadSDKScript() {
  return new Promise((resolve, reject) => {
    if (window.SecureSDK) {
      resolve();
      return;
    }

    // 서버 SDK 로드
    const script = document.createElement('script');
    script.src = `${process.env.VUE_APP_SECURE_AI_CLIENT_SDK_URL}/resources/client.sdk.min.js`;
    script.async = true;
    script.onload = () => {
      console.log('[SDK] 서버 SDK 로드 성공');
      resolve();
    };
    script.onerror = () => reject(new Error('SDK 스크립트 로드 실패'));
    document.body.appendChild(script);
  });
}

store.commit('SET_SDK_READY', false);
store.commit('SET_SDK_ERROR', null);

loadSDKScript()
  .then(() => {
    store.commit('SET_SDK_READY', true);
  })
  .catch((err) => {
    store.commit('SET_SDK_ERROR', err.message || 'SDK 로드 실패');
  });

async function setupSDK(token) {
  // 토큰이 없으면 SDK 초기화하지 않음
  if (!token) {
    console.log('토큰이 없어 SDK 초기화를 건너뜁니다.')
    Vue.prototype.$sdk = null
    return
  }
  
  try {
    const sdk = await initializeSecureSDK(token)
    Vue.prototype.$sdk = sdk
    console.log('SecureSDK 초기화 완료')
  } catch (e) {
    console.error('SecureSDK 초기화 실패:', e)
    Vue.prototype.$sdk = null
  }
}

// 앱 시작 시에는 토큰 체크 후 초기화 (로그인 상태인 경우만)
if (store.state.token) {
  setupSDK(store.state.token)
}

// 토큰이 바뀌면 SDK 재초기화 (로그인/로그아웃 시)
store.watch(
  state => state.token,
  (newToken, oldToken) => {
    if (newToken !== oldToken) {
      setupSDK(newToken)
    }
  }
)

Vue.use(PortalVue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 